import { Company } from './company.model';
import { ModelHelper } from '../classes/model-helper';

export class LinkedPartner {
	hasCredentials: boolean;
	internalPartnerName: string;
	name: string;
	contractors: Company[];

	/**
	 * Static mapping function
	 *
	 * @param data
	 * @param item
	 * @returns LinkedPartner
	 */
	static map(data: any, item: LinkedPartner = new LinkedPartner()): LinkedPartner {
		return item.map(data);
	}

	/**
	 * Non static mapping function
	 *
	 * @param data
	 * @return LinkedPartner
	 */
	public map(data: any): LinkedPartner {
		ModelHelper.map(data, this, 'hasCredentials');
		ModelHelper.map(data, this, 'internalPartnerName');
		ModelHelper.map(data, this, 'name');
		ModelHelper.map(data, this, 'contractors', Company);

		return this;
	}
}
